export const POST_PARTENAIRE_RETURN = 'POST_PARTENAIRE_RETURN';
export const POST_PARTENAIRE_SAGAS = 'POST_PARTENAIRE_SAGAS';

export const GET_PARTENAIRES_RETURN = 'GET_PARTENAIRES_RETURN';
export const GET_PARTENAIRES_SAGAS = 'GET_PARTENAIRES_SAGAS';

export const GET_PARTENAIRE_RETURN = 'GET_PARTENAIRE_RETURN';
export const GET_PARTENAIRE_SAGAS = 'GET_PARTENAIRE_SAGAS';

export const PUT_PARTENAIRE_RETURN = 'PUT_PARTENAIRE_RETURN';
export const PUT_PARTENAIRE_SAGAS = 'PUT_PARTENAIRE_SAGAS';

export const DEL_PARTENAIRE_RETURN = 'DEL_PARTENAIRE_RETURN';
export const DEL_PARTENAIRE_SAGAS = 'DEL_PARTENAIRE_SAGAS';

// POST PARTENAIRE
export const postPartenaireSagas = (xAccess, data) => ({
	type: POST_PARTENAIRE_SAGAS,
	token: xAccess,
	data: data
});
export const postPartenaireReturn = (result) => ({
	type: POST_PARTENAIRE_RETURN,
	payload: result
});

// GET PARTENAIRES
export const getPartenairesSagas = (xAccess) => ({
	type: GET_PARTENAIRES_SAGAS,
	token: xAccess
});
export const getPartenairesReturn = (result) => ({
	type: GET_PARTENAIRES_RETURN,
	payload: result
});

// GET PARTENAIRE
export const getPartenaireSagas = (uuid, xAccess) => ({
	type: GET_PARTENAIRE_SAGAS,
	token: xAccess,
	payload: uuid
});
export const getPartenaireReturn = (result) => ({
	type: GET_PARTENAIRE_RETURN,
	payload: result
});

// PUT PARTENAIRE
export const putPartenaireSagas = (uuid, xAccess, data) => ({
	type: PUT_PARTENAIRE_SAGAS,
	token: xAccess,
	payload: uuid,
	data: data
});
export const putPartenaireReturn = (result) => ({
	type: PUT_PARTENAIRE_RETURN,
	payload: result
});

// DELETE PARTENAIRE
export const deletePartenaireSagas = (uuid, xAccess) => ({
	type: DEL_PARTENAIRE_SAGAS,
	token: xAccess,
	payload: uuid
});
export const deletePartenaireReturn = (result) => ({
	type: DEL_PARTENAIRE_RETURN,
	payload: result
});
